import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import VideoStatusDropDown from './VideoStatusDropDown'
import CommentActions from 'Redux/CommentRedux'
import VideoActions from 'Redux/VideoRedux'
import styles from './ToolBarStyles'

class ToolBar extends Component {
  static propTypes = {
    onVersionChange: PropTypes.func.isRequired,
    video: PropTypes.object,
    versionDropDown: PropTypes.array
  }

  onVersionChange = (_, { value }) => {
    if (this.props.video.id !== value) {
      this.props.commentsSetCurrent({})
      this.props.onVersionChange(value)
    }
  }

  onStatusChange = (_, { value }) => {
    if (this.props.video.status !== value) {
      this.props.videosUpdateRequest(
        this.props.video.id, { status: value }
      )
    }
  }

  render () {
    return (
      <div className={styles.component}>
        <div className={styles.column}>
          <VideoStatusDropDown video={this.props.video} />
        </div>
        <div className={styles.version}>
          <Dropdown
            align='center'
            compact
            selection
            openOnFocus
            placeholder='Select Version'
            options={this.props.versionDropDown}
            value={this.props.video.id}
            onChange={this.onVersionChange}
          />
        </div>
        <div className={styles.download}>
          <Dropdown text='Download'>
            <Dropdown.Menu>
              {this.props.video.sources.map(source => (
                <Dropdown.Item
                  key={source.height}
                  text={source.height + 'p'}
                  as='a'
                  href={source.locationDownloadUrl}
                  download
                />
              ))}
              <Dropdown.Item
                text='Original'
                as='a'
                href={this.props.video.sourceDownloadUrl}
                download
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.videos.updateFetching,
  video: state.videos.currentVideo,
  versionDropDown: state.videos.versionDropDown
})

const mapDispatchToProps = (dispatch) => ({
  commentsSetCurrent: (comment) =>
    dispatch(CommentActions.commentsSetCurrent(comment)),
  videosUpdateRequest: (id, payload) =>
    dispatch(VideoActions.videosUpdateRequest(id, payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(ToolBar)



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/ToolBar/ToolBar.js